// src/utils/metaPixel.js
// Helper para Meta Pixel (Facebook)
// NO dispara nada automático

export const sendMetaPageView = (path) => {
  if (typeof window === "undefined") return;
  if (!window.fbq) return;

  window.fbq("track", "PageView", {
    page_path: path,
  });
};

export const sendMetaEvent = (eventName, params = {}) => {
  if (typeof window === "undefined") return;
  if (!window.fbq) return;

  window.fbq("track", eventName, params);
};
